import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../component/Header";
import { useSwal } from "../../component/sweetalert";
import api from "../../Services/api";

export default function EditLicence() {
  const { id } = useParams();
  const navigate = useNavigate();
  const alert = useSwal();

  const [formData, setFormData] = useState({
    country: "",
    product_name: "",
    price: "",
  });

  useEffect(() => {
    const fetchRenewal = async () => {
      try {
        const response = await api.post(`/getRenewalReplyById/${id}`); // Use GET request
        if (response.data.licence) {
          setFormData({
            country: response.data.licence.country,
            product_name: response.data.licence.product_name,
            price: response.data.licence.price,
          });
        } else {
          throw new Error("Invalid response structure");
        }
      } catch (error) {
        console.error("❌ Error fetching licence:", error);
        alert("error", "Failed to fetch licence details");
      }
    };

    if (id) {
      fetchRenewal();
    }
  }, [id, alert]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/updateRenewal/${id}`, formData);
      alert("success", "Licence updated successfully");
      navigate("/renewal-licence");
    } catch (error) {
      console.error("❌ Error updating licence:", error);
      alert("error", "Failed to update licence details");
    }
  };

  return (
    <section className="dashboardpage">
      <Header pageTitle="Edit Renewal Licence Details"  backTo="/renewal-licence" />
      <div className="pageLeftspace">
      <div className="d-flex justify-content-start col-xl-6 col-12">
        <form className="form-fields d-flex" onSubmit={handleSubmit}>
          <div className="grid-container user">
            <div className="input-container">
              <input
                type="text"
                name="country"
                placeholder="Enter Country Name"
                value={formData.country}
                onChange={handleChange}
                required
                disabled
              />
              {/* <label htmlFor="country">Country Name</label> */}
              <span className="underline"></span>
            </div>

            <div className="input-container">
              <input
                type="text"
                name="product_name"
                placeholder="Enter Product Name"
                value={formData.product_name}
                onChange={handleChange}
                required
                disabled
              />
              {/* <label htmlFor="product_name">Product Name</label> */}
              <span className="underline"></span>
            </div>

            <div className="input-container">
              <input
                type="text"
                name="price"
                placeholder="Enter Price"
                value={formData.price}
                onChange={handleChange}
                required
              />
              {/* <label htmlFor="price">Price</label> */}
              <span className="underline"></span>
            </div>

            <button className="btn btn-purpal" type="submit">
              Update
            </button>

          </div>

        
        </form>
        </div>
      </div>
    </section>
  );
}
